<template>
  <div class="management mb-10">
    <v-tabs
      v-model="tab"
      class="elevation-2"
      flat
    > 
      <v-tab v-if="$cookies.get('user_level')=='INCHARGE' || $cookies.get('user_level')=='ADMIN'" :href="`#tab-experiment`">
        <v-icon>mdi-test-tube</v-icon>{{ $t("manage.by_school.tab.experiment") }}
      </v-tab>
      <v-tab v-if="$cookies.get('user_level')=='INCHARGE' || $cookies.get('user_level')=='ADMIN'" :href="`#tab-user`">
        <v-icon>mdi-account-search</v-icon>{{ $t("manage.by_school.tab.user") }}
      </v-tab>
      <v-tab v-if="$cookies.get('user_level')=='INCHARGE' || $cookies.get('user_level')=='ADMIN'" :href="`#tab-booking`">
        <v-icon>mdi-calendar</v-icon>{{ $t("manage.by_school.tab.booking") }}
      </v-tab>
      <!--v-tab v-if="$cookies.get('user_level')=='INCHARGE' || $cookies.get('user_level')=='ADMIN'" :href="`#tab-announcement`">
        {{ $t("manage.by_school.tab.announcement") }}
      </v-tab-->
      <v-tab v-if="$cookies.get('user_level')=='INCHARGE' || $cookies.get('user_level')=='ADMIN'" :href="`#tab-group-experiment`">
        <v-icon>mdi-account-multiple</v-icon>{{ $t("manage.by_school.tab.group_experiment") }}
      </v-tab>
      <v-tab v-if="$cookies.get('user_level')=='INCHARGE' || $cookies.get('user_level')=='ADMIN'" :href="`#tab-school-info`">
        <v-icon>mdi-information</v-icon>{{ $t("manage.by_school.tab.school_info") }}
      </v-tab>
      <v-tab-item :value="'tab-experiment'">
        <Experiment />
      </v-tab-item>
      <v-tab-item :value="'tab-user'">
        <User />
      </v-tab-item>
      <v-tab-item v-if="$cookies.get('user_level')=='INCHARGE' || $cookies.get('user_level')=='ADMIN'" :value="'tab-booking'">
        <Booking />
      </v-tab-item>
      <!--v-tab-item v-if="$cookies.get('user_level')=='INCHARGE' || $cookies.get('user_level')=='ADMIN'" :value="'tab-announcement'">
        <Announcement />
      </v-tab-item-->
      <v-tab-item v-if="$cookies.get('user_level')=='INCHARGE' || $cookies.get('user_level')=='ADMIN'" :value="'tab-group-experiment'">
        <GroupExperiment />
      </v-tab-item>
      <v-tab-item v-if="$cookies.get('user_level')=='INCHARGE' || $cookies.get('user_level')=='ADMIN'" :value="'tab-school-info'">
        <SchoolInfo />
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import Experiment from "@/views/school/experiment.vue";
import User from "@/views/school/user.vue";
import Booking from "@/views/school/booking.vue";
import GroupExperiment from "@/views/school/group_experiment.vue";
import Announcement from "@/views/school/announcement.vue";
import SchoolInfo from "@/views/school/info.vue";

import {api_general} from '@/services/iot/api_general';
const apiGeneral = new api_general(process.env.VUE_APP_BASE_URL);
export default {
  name: "admin",
  components: {
    Experiment,
    User,
    Booking,
    GroupExperiment,
    Announcement,
    SchoolInfo
  },
  data: () => ({
    tab: null,
    school_id: null,
    api: {
      school: null,
    },
  }),
  mounted() {
    var self = this;
    self.school_id = self.$route.params.school_id;
    let tmp = self.$route.hash.split("#").pop();
    if(tmp!="" || tmp!="tab-user" || tmp!="tab-experiment"){
      self.tab = tmp;
    }
    if(self.$store.state.user.user_level!="ADMIN"){
      self.userSchoolVerify();
    }
/*    if($cookies.get('username') != "admin"){
        self.$store.commit('showSnackBar', "Access Denied");
        self.$router.push("/");
    }
*/
  },
  methods: {
    userSchoolVerify(){
      var self = this;
      apiGeneral.userSchoolVerify(self.$cookies.get('username'), self.school_id)
      .then((response) => {
        if(response.status=="fail"){
          alert(response.error);
        }
        else if(response.status=="success"){
          ;
        }
      });
    },
  }
};
</script>